import { memo, useState } from 'react'

import {
  BackupContactStep,
  CompletionStep,
  ReassignFlagsStep,
  ReassignRolesStep,
  ReassignUniqueRolesStep,
  WelcomeStep,
} from './components/steps'
import { ContactRelinkingStep } from './configs'

type Props = {
  onClose: () => void
  onRelink: (newHpRoles?: string[]) => void
  relinkingNewPartnerId: string
}

export const ContactRelinkingValidationModalContent = memo<Props>(
  ({ onClose, onRelink, relinkingNewPartnerId }) => {
    const [currentStep, setCurrentStep] = useState<ContactRelinkingStep>(
      ContactRelinkingStep.Welcome
    )

    switch (currentStep) {
      case ContactRelinkingStep.Welcome: {
        return (
          <WelcomeStep
            onProceed={setCurrentStep}
            onCancel={onClose}
            relinkingNewPartnerId={relinkingNewPartnerId}
          />
        )
      }
      case ContactRelinkingStep.ReassignUniqueRoles: {
        return <ReassignUniqueRolesStep onProceed={setCurrentStep} onCancel={onClose} />
      }
      case ContactRelinkingStep.ReassignRoles: {
        return <ReassignRolesStep onProceed={setCurrentStep} onCancel={onClose} />
      }
      case ContactRelinkingStep.ReassignFlags: {
        return <ReassignFlagsStep onProceed={setCurrentStep} onCancel={onClose} />
      }
      case ContactRelinkingStep.Backup:
        return <BackupContactStep onProceed={setCurrentStep} onCancel={onClose} />
      case ContactRelinkingStep.Completion: {
        return <CompletionStep onRelink={onRelink} onCancel={onClose} />
      }
      default:
        return null
    }
  }
)

ContactRelinkingValidationModalContent.displayName = 'ContactRelinkingValidationModalContent'
